import React from "react";
import { OtherAttendee } from "./OtherAttendees";

interface OtherAttendeesTableRecordProps {
  attendee: OtherAttendee;
  venueName: string;
  onEditAttendee: () => void;
  onRemoveAttendee: () => void;
}

export default function OtherAttendeesTableRecord({
  attendee: { firstName, lastName, type, phoneNumber, email },
  venueName,
  onEditAttendee,
  onRemoveAttendee,
}: OtherAttendeesTableRecordProps) {
  return (
    <div className="other-attendee-table-row">
      <p>{`${firstName} ${lastName}`.trim()}</p>
      <p>{type}</p>
      <p>{phoneNumber}</p>
      <p>{email}</p>
      <p>{venueName}</p>
      <p className="flex flex-align-center">
        <i
          className="material-icons large-text link-text-secondary"
          onClick={onEditAttendee}
        >
          edit
        </i>
        <i
          className="material-icons large-text ml-8 link-text-secondary"
          onClick={onRemoveAttendee}
        >
          delete
        </i>
      </p>
    </div>
  );
}
